import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/theme";

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      className="theme-toggle-button"
      data-testid="theme-toggle-button"
      title={isDark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      aria-label={isDark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      onClick={toggleTheme}
    >
      {isDark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}
